import React from "react"
import PressReleasesGrid from "./press-releases-grid"
import OutcomeSection from "../index-components/outcome-section"
import RequestDemoSection from "../request-demo-section"

const PressHero = ({ pressReleases }) => {
  return (
    <section className="hero has-background-dark hero-press">
      <div className="hero-title-container">
        <div className="container">
          <h1 className="title is-1 is-size-3-mobile has-text-white mb-4 has-line-height-1 has-text-centered">
            Press Releases
          </h1>
        </div>
      </div>
      <div className="hero-body">
        <PressReleasesGrid pressReleases={pressReleases} />
        <span className="press-releases-grid-contact">
          For press inquiries please contact us at{" "}
          <a href="mailto:press@inpowered.ai">press@inpowered.ai</a>
        </span>
        <div className="press-hero-divider"></div>

        <div className="container mt-6">
          <h2 className="has-text-centered is-size-2 is-size-2-mobile has-text-weight-semibold has-text-purple">
            Explore Solutions
          </h2>
          <div className="mt-5 mb-6">
            <OutcomeSection showDescription={false} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default PressHero
